import { Link } from "react-router-dom";
import { useState } from "react";

/**
 * Image-forward library card: a full SQUARE cover (no cropping of the square
 * art), with the title/subtitle as secondary text below. Hovering the cover
 * reveals the short description as an overlay — image first, words on demand.
 * Falls back to the ॐ mark if no cover is set OR the cover fails to load.
 */
export function LibraryCard({
  to,
  coverImage,
  eyebrow,
  title,
  subtitle,
  excerpt,
}: {
  to: string;
  coverImage?: string | null;
  eyebrow?: string | null;
  title: string;
  subtitle?: string | null;
  excerpt?: string | null;
}) {
  const [imgFailed, setImgFailed] = useState(false);
  return (
    <Link to={to} className="group block">
      <div className="media-frame aspect-square transition-colors">
        {coverImage && !imgFailed ? (
          <img
            src={coverImage}
            alt=""
            loading="lazy"
            onError={() => setImgFailed(true)}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
          />
        ) : (
          <div className="w-full h-full grid place-items-center font-display text-[3rem] text-[var(--color-ink-light)]">
            ॐ
          </div>
        )}
        {excerpt && (
          <div className="absolute inset-0 flex items-end bg-ink/85 opacity-0 group-hover:opacity-100 transition-opacity duration-200 p-4">
            <p className="font-grotesk text-[0.85rem] leading-[1.55] text-[var(--color-vellum)] line-clamp-6">
              {excerpt}
            </p>
          </div>
        )}
      </div>
      <div className="pt-2.5">
        {eyebrow && (
          <p className="font-grotesk text-[0.6rem] tracking-[0.16em] uppercase text-[var(--color-ink-mute)]">
            {eyebrow}
          </p>
        )}
        <p className="font-display text-[1.2rem] leading-[1.2] tracking-tight mt-0.5 group-hover:text-[var(--color-violet)] transition-colors line-clamp-2">
          {title}
        </p>
        {subtitle && (
          <p className="font-display-italic text-[0.92rem] text-[var(--color-ink-mute)] leading-[1.3] mt-0.5 line-clamp-1">
            {subtitle}
          </p>
        )}
      </div>
    </Link>
  );
}
